///////////////////////////////////////////////////

import { liveQuoteFormApiConnector } from 'apiConnector/secondary-market/live/form';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { liveOriginalFormActions } from 'state/secondaryMarket/live/form/original/liveOriginalForm.actions';
import { liveThunks } from 'state/secondaryMarket/live/live.thunk';
import type { EpicWithThunk } from 'state/state.common';

export function loadLiveOrderToAmendEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { getOrderById } = liveQuoteFormApiConnector(httpClient);
    return actions$.pipe(
      ofType('SECONDARY_MARKET_AMEND_LIVE_FETCH_REQUESTED'),
      mergeMap(({ orderId, tabId }) =>
        getOrderById(orderId).pipe(
          map(response => liveThunks.amendFetchedThunk(tabId, orderId, response)),
          catchError((err: Error) => of(liveOriginalFormActions.secondaryMarketAmendFetchFailed(tabId, err?.message))),
        ),
      ),
    );
  };
}
